import React, { useMemo, useState } from "react";
import { getLabel } from "../locale";
import { ua } from '../ua';

export const ALINK_LS_NAME = 'weapp-utils-alink-noRemind';

const Content = React.forwardRef<{}, {}>(() => {
  const [value, setValue] = useState(false);

  function onChange(v: boolean) {
    window.localStorage?.setItem(ALINK_LS_NAME, `${v}`);
    setValue(v);
  }

  function onTouchStart() {
    onChange(!value);
  }
  
  const tipStyle = useMemo(() => {
    if (ua.device === 'PC') {
      return { paddingBottom: 15 };
    }
    return { paddingBottom: 25 }
  }, []);

  const checkStyle = useMemo(() => {
    if (ua.device !== 'PC') {
      return { fontSize: 14 }
    }
    return {}
  }, []);

  const Checkbox = window.weappUi?.Checkbox;
  return <div>
    <div style={tipStyle}>{getLabel('58926','您正在打开未验证的链接，可能包含未知的安全隐患，确认要打开吗?')}</div>
    {
      Checkbox && <Checkbox onChange={onChange} value={value} style={checkStyle}><span onTouchStart={onTouchStart}>{getLabel('184760','不再提醒')}</span></Checkbox>
    }
  </div>
})

export default Content;